<template>
    <div
        class="header-mine"
        id="header-mine"
    >
        <el-container>
            <el-header>
                <div class="header-mine-top">
                    <div class="header-index-top">
                        <img @click="toHome"
                            class="mine-logo"
                            src="/static/images/mine-logo.jpg"
                        />
                        <div class="header-index-top-left">
                            <a>您好，欢迎来到惠旅商城！中惠旅股票代码：834260</a>
                        </div>
                        <div class="header-index-top-right">
                            <a class="header-index-top-right-hq">我的惠旅商城</a>
                            <!-- <a>超级会员</a>
                            <a>帮助</a> -->
                            <el-divider direction="vertical"></el-divider>
                            <a><img src="/static/images/header-index-top-weibo.png" /></a>
                            <a><img src="/static/images/header-index-top-weixin.png" /></a>
                            <el-divider direction="vertical"></el-divider>
                            <!-- <a>在线客服</a> -->
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
                <div class="header-mine-mune">
                    <el-menu
                        class="el-menu-demo"
                        mode="horizontal"
                        @select="handleSelect"
                        router
                        :default-active="activeIndex"
                    >
                        <el-menu-item index="/mine/index">首页</el-menu-item>
                        <!-- <el-menu-item index="/mine/myInformation">账户设置</el-menu-item> -->
                        <el-menu-item index="/mine/bigNews">消息
                            <!-- <el-badge
                                :value="0"
                                class="item"
                            >消息</el-badge> -->
                        </el-menu-item>
                    </el-menu>
                </div>
            </el-header>
            <el-container class="mine-content">
                <el-aside width="200px">
                    <h5 class="myHuiqu-title">我的惠旅商城</h5>
                    <el-menu
                        class="el-menu-vertical-header-mine"
                        background-color="white"
                        text-color="#333333"
                        active-text-color="#ffd04b"
                        :default-active="activeIndex"
                        router
                    >
                        <NavMenu :navMenus="activeMenu"></NavMenu>
                    </el-menu>
                </el-aside>
                <el-main class="mine-main">
                    <router-view />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import NavMenu from './navMenu-mine'
export default {
  name: 'header-mine',
  components: {
    'NavMenu': NavMenu
  },
  data () {
    return {
      activeIndex: '/mine/index',
      activeIndex2: '1',
      activeMenu: [],
      menuData: {
        '/mine/index':
                {
                  abc: [
                    {
                      // 一级
                      entity: { id: 0, name: 'aa', icon: 'el-icon-s-custom', alias: '个人中心' },
                      childs: [
                        // { entity: { id: 1, name: 'myCollection', alias: '我的收藏', value: { path: '/myCollection' } } },
                        { entity: { id: 2, name: 'pictureEvaluate', alias: '晒图评价', value: '/pictureEvaluate' } }
                        // { entity: { id: 3, name: 'stationNews', alias: '站内消息', value: '/stationNews' } }
                      ]
                    },
                    { // 一级
                      entity: { id: 1, name: 'systemManage', icon: 'el-icon-document', alias: '订单中心' },
                      // 二级
                      childs: [
                        { entity: { id: 1, name: 'myOrder', alias: '我的订单', value: { path: '/myOrder' } } }
                      ]
                    },
                    { // 一级
                      entity: { id: 2, name: 'assetCenter', icon: 'el-icon-s-goods', alias: '资产中心' },
                      // 二级
                      childs: [
                        { entity: { id: 1, name: 'coupon', alias: '优惠券', value: { path: '/coupon' } } },
                        { entity: { id: 2, name: 'myIntegral', alias: '我的积分', value: { path: '/myIntegral' } } }
                      ]
                    }
                  ]
                },
        // '/mine/myInformation': {
        //   abc: [
        //     {
        //       // 一级
        //       entity: { id: 0, name: 'aa', icon: 'el-icon-suitcase', alias: '账户设置' },
        //       childs: [
        //         { entity: { id: 1, name: 'myInformation', alias: '我的信息', value: { path: '/myInformation' } } },
        //         { entity: { id: 2, name: 'myPhoto', alias: '我的头像', value: '/myPhoto' } },
        //         { entity: { id: 3, name: 'bindingSeting', alias: '绑定设置', value: '/bindingSeting' } },
        //         { entity: { id: 4, name: 'accountSecurity', alias: '账户安全', value: '/accountSecurity' } }
        //       ]
        //     }
        //   ]
        // },
        '/mine/bigNews': {}
      }

    }
  },
  created () {
    this.activeMenu = this.menuData['/mine/index'].abc
  },
  methods: {
    handleSelect (key, keyPath) {
      this.activeMenu = this.menuData[key].abc
    },
    toHome () {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
$width: 1200px;
$bgColor: #ec6619;
.header-mine {
    background-color: white;
}
.mine-content {
    width: 1200px;
    margin: 43px auto 0px;
    .myHuiqu-title {
        font-size: 18px;
        color: #333333;
        background-image: url("/static/images/mine-myHuiqu-title-bg.png");
        background-size: 100% 100%;
        height: 86px;
        line-height: 86px;
        margin: 0px;
    }
}
.el-header {
    color: #333;
    text-align: center;
    padding: 0px;
}
.mine-logo {
    width: 78px;
    height: 82px;
    background-color: $bgColor;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 99;
    border: 10px solid $bgColor;
}
.el-aside {
    background-color: white;
    color: #333;
    text-align: center;
    border: 1px solid #e5e5e5;
}

.el-main {
    color: #333;
    padding: 31px 0px 18px 24px;
}
.header-mine-top {
    background-color: #f4f4f4;
}
.header-index-top {
    position: relative;
    width: $width;
    margin: 0 auto;
    font-size: 12px;
    color: #666666;
    padding: 8px 0px;
    .header-index-top-left {
        margin-left: 120px;
        img {
            vertical-align: bottom;
        }
    }
    .header-index-top-left {
        float: left;
        .header-index-top-left-place {
            margin: 0px 5px;
        }
    }
    .header-index-top-right {
        float: right;
        .header-index-top-right-hq {
            color: #ec6619;
        }
        a {
            margin-right: 10px;
        }
    }
    .clear {
        clear: both;
    }
}
.header-mine-mune {
    background-color: white;
    position: relative;
    border-bottom: 3px solid $bgColor;
    padding-bottom: 4px;
    .el-menu-demo {
        width: $width;
        margin: 0 auto;
    }
    .el-menu--horizontal > .el-menu-item:first-child {
        margin-left: 120px;
    }
    .el-menu.el-menu--horizontal {
        border-bottom: 0px;
    }
}
.mine-main {
    min-height: 600px;
}
</style>
<style lang="scss">
.header-mine {
    .el-menu {
        border: none;
    }
    .el-aside {
        overflow: hidden;
    }
    .el-menu--horizontal .el-menu-item.is-active {
      border-bottom: 2px solid #EC6619!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/header-mine.vue